import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "control-sidebar control-sidebar-dark",
  style: {"padding":"16px","padding-top":"73px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Customize AdminLTE", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-2" }, null, -1)
const _hoisted_4 = { style: {"padding":"8px 0"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Dark mode ")

export function render(_ctx, _cache) {
  const _component_app_checkbox = _resolveComponent("app-checkbox")

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_app_checkbox, { onChange: _ctx.handleDarkModeChange }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onChange"])
    ])
  ]))
}